import type { FC } from 'react';
import * as React from 'react';
import type { FormikProps } from 'formik';

import { v4 } from 'uuid';
import { ReceiptBatchImageInput } from '@pflegenavi/shared-web/receipt-batch';
import {
  useGetReceiptImagesWithTenant,
  useUploadReceiptImage,
} from '@pflegenavi/service-provider-frontend/api';
import type { ReceiptBatchFormValues } from './interfaces/ReceiptBatchFormValues';
import { computeMd5HashOfFile } from '@pflegenavi/shared-web/hash-utils';

export const renderReceiptBatchImageInput = (
  formik: FormikProps<ReceiptBatchFormValues>
): React.ReactElement => {
  return <ReceiptBatchImageTestInput formik={formik} />;
};
const ReceiptBatchImageTestInput: FC<{
  formik: FormikProps<ReceiptBatchFormValues>;
}> = ({ formik }) => {
  const {
    values: { tenant },
  } = formik;
  const { upload, uploadState } = useUploadReceiptImage({
    tenant: tenant ?? '',
    uuid: v4,
    computeMd5Hash: computeMd5HashOfFile,
  });

  const useGetReceiptUrls = useGetReceiptImagesWithTenant({
    tenant: tenant ?? '',
  });

  const handleSetBatchImages = (images: string[]) => {
    formik.setFieldValue('batchImageIds', images);
  };

  return (
    <ReceiptBatchImageInput
      batchImageIds={formik.values.batchImageIds ?? []}
      handleSetBatchImages={handleSetBatchImages}
      uploadState={uploadState}
      uploadFile={upload}
      useReceiptImages={useGetReceiptUrls}
      autoGenerateReceipts={formik.values.generateReceipts}
      selectedNursingHomeId={formik.values.nursingHomeId}
      appMode={'service-provider'}
    />
  );
};
